


















































































import * as AceEditor from 'brace'
import { Editor } from 'brace'
import * as searchbox from 'brace/ext/searchbox'
import * as LanguageTools from 'brace/ext/language_tools'
import * as tomorrowNight from 'brace/theme/tomorrow_night'
import * as qsyntax from '../../../lib/qsyntax'
import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
import ImageApi from '../api/ImageAPI'
import QuestionType from '../lib/QuestionType'
import Question from '../models/Question'
import { QUESTION_SURVEY_TYPES, QUESTION_TEST_TYPES, QUESTION_TYPES } from '../const/question-types'
import { BusAction } from '../store-helper'
import { isEqual } from 'underscore'
import { CursoPosition } from '../types'
import AutoCompleter from '../lib/AutoCompleter'
import IndentProcess from '../lib/IndentProcess'
import { qEditorState } from '../stores'
import { mathliveState } from '../stores/mathlive'
import { mathLiveToLatex, latexToMathLive, detectMath } from '../../../lib/mathlive'
import hotkeys from 'hotkeys-js'
import ExamGenerationForm from '../../api/v2/forms/exam_generation'
import api from '../../api/v2/api'
import { asyncSleep } from '../../client/utils/utils'
const mode = {
  tomorrowNight,
  LanguageTools,
  qsyntax,
  searchbox
}
const MarkerRange = AceEditor.acequire('ace/range').Range
@Component({})
export default class EditorComponent extends Vue {
  @Prop() editorId: string
  private editor: Editor
  private skipUpdateContent: 'skip_dispatch' | 'skip_update' | 'none' | 'skip_all'
  private beforeCursoPosition: CursoPosition = null
  private markers: number[] = []

  promptForQuestions = JSON.parse(document.getElementById("question_editor_data").dataset.prompts)
      .filter(prompt => prompt.category == "auto_question")
  selectedQuestionPromptId = null
  instructionQuestionForUser = ""
  showAutoQuestionStatus = false

  get questions() {
    return qEditorState.questions
  }

  get exam() {
    return qEditorState.exam
  }

  get skills() {
    return qEditorState.skills
  }

  get school() {
    return qEditorState.school
  }

  get body() {
    return qEditorState.body
  }

  get errorLines() {
    return qEditorState.errorLines
  }

  @BusAction on
  get cursoPosition() {
    return qEditorState.cursoPosition
  }

  get currentPage() {
    return qEditorState.displayCurrentPage
  }

  get isRevisionMode() {
    return qEditorState.isRevisionMode
  }

  constructor() {
    super()
  }

  @Watch('selectedQuestionPromptId')
  watchSelectedQuestionPromptId(val) {
    const selectedPrompt = this.promptForQuestions.find(prompt => prompt.id == val)
    this.instructionQuestionForUser = selectedPrompt ? selectedPrompt.instruction_for_user : ""
  }

  @Watch('showAutoQuestionStatus')
  watchShowAutoQuestionStatus() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 500)
  }

  mounted() {
    this.on({ event: 'focus', callback: this.focus })
    this.$nextTick(this.setupAceEditor)

    this.settupHotKeys()
  }

  settupHotKeys() {
    this.removeHotkeys()

    hotkeys.filter = (event) => {
      return true
    }

    hotkeys('alt+m', 'editor', () => {
      this.detectMathSession(this.cursoPosition)
    })

    hotkeys.setScope('editor')
  }

  removeHotkeys() {
    hotkeys.deleteScope('editor')
  }

  beforeDestroy() {
    this.removeHotkeys()
  }

  private get surveyTypes() {
    return QUESTION_SURVEY_TYPES
  }

  private get testTypes() {
    return QUESTION_TEST_TYPES
  }

  private get questionTypes(): QuestionType[] {
    return (this.surveyTypes || []).concat(this.testTypes || [])
  }

  private getQuestion() {
    return qEditorState.question
  }

  private getQuestionTypes() {
    return this.questionTypes
  }

  private getSkills() {
    return this.skills
  }

  @Watch('isRevisionMode')
  watchEditorMode() {
    if (!this.editor) {
      return
    }

    if (this.isRevisionMode) {
      this.editor.setReadOnly(true)
    } else {
      this.editor.setReadOnly(false)
    }
  }

  private setupAceEditor() {
    const editor = (this.editor = AceEditor.edit(this.editorId))
    new IndentProcess(this.editor)
    const autocompleter = new AutoCompleter(this.getQuestion, this.getQuestionTypes, this.getSkills)

    const snippetManager = AceEditor.acequire('ace/snippets').snippetManager
    const snippets = snippetManager.parseSnippetFile('snippet test\n  TEST!')
    this.questionTypes.forEach((questionType) => questionType.snippets.forEach((snippet) => snippets.push(snippet)))
    snippetManager.register(snippets, 'qsyntax')

    const langTools = AceEditor.acequire('ace/ext/language_tools')
    langTools.setCompleters([])
    langTools.addCompleter(autocompleter.completer())
    this.editor.$blockScrolling = Infinity
    this.editor.setOptions({
      enableBasicAutocompletion: true,
      enableSnippets: true,
      enableLiveAutocompletion: true
    })
    this.editor.setValue(this.body, 1)

    const qsyntax = AceEditor.acequire('ace/mode/qsyntax')
    this.editor.getSession().setMode(`ace/mode/qsyntax`)
    this.editor.getSession().setUseWrapMode(true)
    this.editor.setTheme(`ace/theme/tomorrow_night`)
    this.editor.setBehavioursEnabled(false)

    const that = this
    this.editor.on('change', (e) => {
      if (this.skipUpdateContent == 'skip_all') return
      if (this.skipUpdateContent == 'skip_dispatch') return
      
      const body = that.editor.getSession().getValue()
      that.skipUpdateContent = 'skip_update'
      qEditorState.editBody({ body })
      that.updateCurrentLine()
      setTimeout(() => (that.skipUpdateContent = 'none'), 0)
    })

    this.editor.on('paste', (event) => {
      if (event.event.clipboardData.files.length > 0) event.text = ''
    })
    self.document.getElementById(this.editorId).addEventListener('paste', this.onPaste, false)
    self.document.getElementById(this.editorId).addEventListener('dragover', (e) => e.preventDefault(), false)
    self.document.getElementById(this.editorId).addEventListener('drop', (e) => e.preventDefault(), false)

    this.editor.on('changeSelection', () => {
      if (!isEqual(this.beforeCursoPosition, this.editor.selection.getCursor())) {
        this.beforeCursoPosition = this.editor.selection.getCursor()
        qEditorState.commitEditCursoPosition({
          row: this.beforeCursoPosition.row,
          column: this.beforeCursoPosition.column
        })
      }
      qEditorState.commitEditRange({ range: this.editor.selection.getRange() })
      this.updateCurrentLine()
    })

    this.on({
      event: 'insertSnippet',
      callback: (snippet) => {
        let snippetContent = snippet.content
        const selectedText = (this.editor as any).getSelectedText()
        const innerText = selectedText || '内容'

        switch (snippet.type) {
          case 'heading':
            snippetContent = '# ${1:' + innerText + '}\n'
            break
          case 'bold':
            snippetContent = '** ${1:' + innerText + '} **'
            break
          case 'quote':
            snippetContent = '> ${1:' + innerText + '}\n'
            break
          case 'link':
            snippetContent = '[${1:' + innerText + '}](${2:http://}) '
            break
          case 'color':
            snippetContent = '<span style="color:' + snippetContent + '">' + innerText + '</span>'
            break
          case 'list':
            snippetContent = '- ${1:' + innerText + '}\n'
            break
          case 'fontsize':
            editor.setOptions({
              fontSize: `${snippet.fontSize}px`,
            })
            break
          case 'mathlive':
            mathliveState.show('', (latex: string) => {
              snippetManager.insertSnippet(editor, latexToMathLive(latex))
              editor.focus()
            })
            return
            break
        }
        snippetManager.insertSnippet(editor, snippetContent)
      }
    })

    // retain CKEditor scroll bar at cursor position
    // self.document.getElementById(this.editorId).scrollIntoView()

    qEditorState.setExamGenerationChanelCallback((content: string, chunk: string, finished: boolean)=>{
      this.examGenerationQueue.push({
        content,
        chunk,
        finished
      })
    })
  }

  examGenerationQueue: {
    content: string,
    chunk: string,
    finished: boolean,
  }[] = []
  private async processExamGenerationQueue(editor: AceEditor.Editor){
    let currentBody = editor.getSession().getValue();
    let currentCursor = editor.selection.getCursor();
    this.examGenerationLoading = true
    while (true) {
      if (this.examGenerationQueue.length > 0) {
        const chunk = this.examGenerationQueue.splice(0, 1)[0];
        editor.getSession().setValue(currentBody)
        editor.moveCursorTo(currentCursor.row, currentCursor.column);
        editor.insert(chunk.content)

        var cursor = editor.selection.getCursor();
        editor.scrollToLine(cursor.row, true, true, ()=>{})

        // 終わったら終了します。
        if (chunk.finished) {
          this.examGenerationLoading = false
          return
        }
      }
      await asyncSleep(10)
    }
  }

  private setMarker() {
    this.markers.forEach((marker) => this.editor.getSession().removeMarker(marker))
    this.markers = []

    let line = 0
    this.questions.forEach((question) => {
      if (line > 0) {
        const range = new MarkerRange(line, 0, line, this.editor.session.getLine(line).length)
        this.markers.push(this.editor.getSession().addMarker(range, `${question.index} つ目        `, 'line', false))
        line += 1
      }
      line += question.length
    })
  }

  private async onPaste(event) {
    if (event.clipboardData.files[0]) {
      const editor = this.editor
      const range = editor.selection.getRange()
      const upload_text = '![uploading image](/Spinner.gif)'
      const uploaded_text = 'image'
      range.end.column += upload_text.length
      editor.session.insert(editor.getCursorPosition(), upload_text)
      const url = await ImageApi.upload(this.exam, event.clipboardData.files[0])
      const url_link = '![' + uploaded_text + '](' + url + ')'
      editor.session.replace(range, url_link)
    }
    event.preventDefault()
  }

  @Watch('body')
  onBodyChanged(value: string) {
    if (this.skipUpdateContent == 'skip_all') return
    if (this.skipUpdateContent == 'skip_update') return
    
    this.setMarker()
    const that = this
    const oldPosition = { row: this.editor.selection.getCursor().row, column: this.editor.selection.getCursor().column }
    this.skipUpdateContent = 'skip_dispatch'
    this.editor.getSession().setValue(value)
    this.editor.moveCursorTo(oldPosition.row, oldPosition.column)
    setTimeout(() => (that.skipUpdateContent = 'none'), 0)
  }

  @Watch('questions')
  onQuestionsChanged(questions: Question[]) {
    this.setMarker()
  }

  @Watch('cursoPosition')
  onCursoPositionChanged(value: CursoPosition) {
    if (!isEqual(this.beforeCursoPosition, value)) {
      this.beforeCursoPosition = value
      this.editor.moveCursorTo(value.row, value.column)
    }
  }

  detectMathSession(cursor: CursoPosition) {
    const curentLine: string = this.editor.session.getLine(cursor.row)
    const matchMaths = detectMath(curentLine)

    for (let index = 0; index < matchMaths.length; index++) {
      const matchMath = matchMaths[index]

      const mathCode = matchMath.mathCode

      // Check hash math code and current cursor in math code
      if (cursor.column > matchMath.index && cursor.column < matchMath.index + mathCode.length) {
        const latex = mathLiveToLatex(mathCode)
        mathliveState.show(latex, (newLatex: string) => {
          const newLineStart = curentLine.slice(0, matchMath.index)
          const newLineEnd = curentLine.slice(matchMath.index + mathCode.length)

          const newLine = `${newLineStart}${latexToMathLive(newLatex)}${newLineEnd}`

          const range = new MarkerRange(cursor.row, 0, cursor.row, Number.MAX_VALUE)
          this.editor.session.replace(range, newLine)
          this.editor.focus()
        })
        return
      }
    }

    // 既存の数学がない場合、新しい作る
    mathliveState.show('', (newLatex: string) => {
      if (newLatex) {
        (this.editor as any).insertSnippet(latexToMathLive(newLatex))
        this.editor.focus()
      }
    })
  }

  @Watch('currentPage')
  onCurrentPageChanged(value: number) {
    const isFocused = this.editor.isFocused() as any
    if (isFocused) return

    const searchBox = (this.editor as any).searchBox
    if (searchBox && searchBox.activeInput == document.activeElement) return

    let row: number
    // TODO can we refactor this?
    let body = this.body
      .replace(/\n===+\n/g, '\n---\n')
      .split(/\n---+\n/)
      .splice(0, value - 1)
      .join('\n---\n')
    if (body == '') row = 0
    else row = body.split('\n').length + 1
    row = row == 1 ? 0 : row // First row has no spliter

    this.editor.focus()
    const that = this
    this.editor.scrollToLine(Math.max(row - 1, 0), false, true, () => {})
    setTimeout(() => {
      that.editor.moveCursorTo(row, 0)
      that.editor.selection.clearSelection()
    }, 0)
  }

  private updateCurrentLine() {
    const currentLine = this.editor.getSelectionRange().start.row
    const content = this.editor.session.getLine(currentLine)
    const previousLineContent = currentLine >= 0 ? this.editor.session.getLine(currentLine - 1) : null
    qEditorState.commitSetCurrentLine({ content, previousLineContent })
  }

  public focus() {
    this.editor.focus()
  }

  public async onDrop(event) {
    if (event.dataTransfer.files.length > 0) {
      const editor = this.editor
      const file = event.dataTransfer.files[0]
      const range = editor.selection.getRange()
      const upload_text = '![uploading ' + file.name + '](/Spinner.gif)'
      const uploaded_text = file.name
      range['end']['column'] += upload_text.length
      editor.session.insert(editor.getCursorPosition(), upload_text)
      event.text = ''
      const url = await ImageApi.upload(this.exam, file)
      const url_link = '![' + uploaded_text + '](' + url + ')'
      editor.session.replace(range, url_link)
    }
  }


  msg = ""
  examGenerationLoading = false

  async sendMessage(){
    qEditorState.setFollowExamGenerationChanel()
    const form = new ExamGenerationForm()
    form.promptId = this.selectedQuestionPromptId
    form.body = this.msg
    await api.admin.examGeneration.post(
      qEditorState.exam.id,
      form
    )
    this.processExamGenerationQueue(this.editor)
  }

  stopMessage(){
    qEditorState.setStopExamGenerationChanel()
  }
}
